<script lang="ts">
	interface Props {
		strokeColor?: string
	}

	let { strokeColor = "black" }: Props = $props()
</script>

<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M4 3V21"
		stroke={strokeColor}
		stroke-width="4"
		stroke-linecap="round"
		class="svg-stroke"
	/>
	<path
		d="M20 3V21"
		stroke={strokeColor}
		stroke-width="4"
		stroke-linecap="round"
		class="svg-stroke"
	/>
</svg>

<style>
</style>
